<template>
  <div class="shoplist">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import axios from 'axios'

export default{
    data(){
        return{
            shopList:new Object,
            apiPath : "https://yygj.darenlaiye.com/drzf/wj.aspx",
        }
    },
    mounted(){
        
    },
    methods:{
        loadShopList(){
            //axios.get
        }
    }
}
</script>